import { Alert, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { TenantMembersSettings } from "./settings/TenantMembersSettings";

export function PageTenantSettings() {
  const { tenant } = useParams<{ tenant: string }>();
  const tenantSlug = tenant ?? null;

  if (!tenantSlug) {
    return (
      <Box>
        <Alert severity="warning">Missing tenant in URL. Please navigate from a tenant.</Alert>
      </Box>
    );
  }

  return <TenantMembersSettings tenantSlug={tenantSlug} />;
}
